import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../Styles/verification.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const EmailVerificationSuccess = () => {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // Get token from URL query parameters
        const params = new URLSearchParams(location.search);
        const token = params.get('token');

        if (!token) {
          setStatus('error');
          setMessage('Verification token is missing');
          return;
        }

        // Call verification API
        const response = await fetch(`${API_URL}/api/auth/verify-email?token=${token}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        const data = await response.text();

        if (response.ok) {
          setStatus('success');
          setMessage('Your email has been successfully verified!');
        } else {
          setStatus('error');
          setMessage(data || 'Email verification failed. Please try again.');
        }
      } catch (error) {
        console.error('Verification error:', error);
        setStatus('error');
        setMessage('An error occurred during verification. Please try again later.');
      }
    };

    verifyEmail();
  }, [location]);

  const handleGoToLogin = () => {
    navigate('/signin');
  };

  return (
    <div className="verification-container">
      <div className="verification-card">
        {status === 'loading' && (
          <div className="verification-loading">
            <div className="spinner"></div>
            <p>Verifying your email...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="verification-success">
            <div className="verification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <h1>Email Verified!</h1>
            <p>{message}</p>
            <p>You can now log in to your account.</p>
            <button className="verification-button" onClick={handleGoToLogin}>
              Go to Login
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="verification-error">
            <div className="verification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#f44336" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </div>
            <h1>Verification Failed</h1>
            <p>{message}</p>
            <p>Please try again or contact support if the problem persists.</p>
            <button className="verification-button" onClick={handleGoToLogin}>
              Go to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerificationSuccess;
